import Client from "./client";

export default class Functions {
    constructor() {
        this.client = new Client()
    }

    async all(params = {}) {
        return await this.client.http().get("/v1/system/function", { params })
    }

    async create(data) {
        return await this.client.http().post("/v1/system/function", data)
    }

    async update(uuid, data) {
        return await this.client.http().patch(`/v1/system/function/${uuid}`, data)
    }

    async get(uuid) {
        return await this.client.http().get(`/v1/system/function/${uuid}`)
    }

    async delete(uuid) {
        return await this.client.http().delete(`/v1/system/function/${uuid}`)
    }

    async generateSignature(ref, env) {
        return await this.client.http().delete(`/v1/system/function/signature/${env}/${ref}`)
    }
}